import * as React from 'react';
import FormFields from './FormFields.js';
import { TCPADisclaimerContainer, FormDisclaimer, StepCounter } from './Form.styles.js';
import DetermineFieldType from './DetermineFieldType.js';

var FormSteps = function FormSteps(_ref) {
  var currentStep = _ref.currentStep,
    formDisclaimerPosition = _ref.formDisclaimerPosition,
    formName = _ref.formName,
    nextStep = _ref.nextStep,
    steps = _ref.steps,
    submitButton = _ref.submitButton,
    tcpaCheckbox = _ref.tcpaCheckbox,
    _ref$disclaimer = _ref.disclaimer,
    disclaimer = _ref$disclaimer === void 0 ? null : _ref$disclaimer,
    _ref$smartyStreetsWeb = _ref.smartyStreetsWebsiteKey,
    smartyStreetsWebsiteKey = _ref$smartyStreetsWeb === void 0 ? null : _ref$smartyStreetsWeb;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormFields, {
    className: "step-".concat(currentStep + 1, " ").concat(formName),
    nextStep: nextStep,
    submitButton: submitButton,
    fields: steps[currentStep].formFields,
    additional: currentStep + 1 === steps.length && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TCPADisclaimerContainer, null, tcpaCheckbox && formDisclaimerPosition === 'Above Submit Button' && /*#__PURE__*/React.createElement(DetermineFieldType, {
      submitButton: submitButton,
      field: {
        type: 'checkbox',
        element: 'checkbox',
        name: 'tcpa-checkbox',
        required: true,
        options: [{
          name: 'consent',
          value: 'yes',
          label: ''
        }]
      }
    }), disclaimer && formDisclaimerPosition === 'Above Submit Button' && /*#__PURE__*/React.createElement(FormDisclaimer, disclaimer.brandy)), submitButton, /*#__PURE__*/React.createElement(TCPADisclaimerContainer, null, tcpaCheckbox && formDisclaimerPosition !== 'Above Submit Button' && /*#__PURE__*/React.createElement(DetermineFieldType, {
      submitButton: submitButton,
      field: {
        type: 'checkbox',
        element: 'checkbox',
        name: 'tcpa-checkbox',
        required: true,
        options: [{
          name: 'consent',
          value: 'yes',
          label: ''
        }]
      }
    }), disclaimer && formDisclaimerPosition !== 'Above Submit Button' && /*#__PURE__*/React.createElement(FormDisclaimer, disclaimer.brandy))),
    radioFieldsAsButtons: true,
    smartyStreetsWebsiteKey: smartyStreetsWebsiteKey
  }), /*#__PURE__*/React.createElement(StepCounter, {
    className: "leshen-form-step-counter",
    variant: "small"
  }, "Step ", currentStep + 1, " of ", steps.length));
};
var FormSteps$1 = FormSteps;

export { FormSteps$1 as default };
//# sourceMappingURL=FormSteps.js.map
